import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import Logo from '../../assets/images/neethusLogo.png';
import { TbPhoneCall, TbSmartHome, TbBook, TbNotes } from "react-icons/tb";
import { RiWhatsappFill } from "react-icons/ri";
import { CgClose } from "react-icons/cg";
import { GoChevronRight } from "react-icons/go";
import { FaRegUser } from "react-icons/fa"
import toast, { Toaster } from 'react-hot-toast';;

const path = "/neethusapp";

const Nav = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeSection, setActiveSection] = useState('');
    const [isPopupActive, setIsPopupActive] = useState(false);
    const [isEmailPopupActive, setIsEmailPopupActive] = useState(false);
    const [showShimmer, setShowShimmer] = useState(false);
    const [selectedCourse, setSelectedCourse] = useState('');
    const [email, setEmail] = useState('');

    useEffect(() => {
        const sections = document.querySelectorAll('section');
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setActiveSection(entry.target.id);
                    }
                });
            },
            {
                threshold: 0,
            }
        );

        sections.forEach((section) => observer.observe(section));

        return () => {
            sections.forEach((section) => observer.unobserve(section));
        };
    }, []);

    useEffect(() => {
        const handlePopState = () => {
            setIsPopupActive(false);
            setIsEmailPopupActive(false);
            setShowShimmer(false);
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);

    const handleScroll = (id) => {
        if (location.pathname !== `${path}/`) {
            // Navigate to the Home page with state to specify the target section
            navigate(`${path}`, { state: { scrollTo: id } });
        } else {
            // Scroll directly if already on the Home page
            scrollToSection(id);
        }
    };


    const scrollToSection = (id) => {
        setTimeout(() => {
            const target = document.querySelector(id);
            if (target) {
                const offset = 0; // Adjust offset if needed
                const bodyRect = document.body.getBoundingClientRect().top;
                const elementRect = target.getBoundingClientRect().top;
                const position = elementRect - bodyRect - offset;

                window.scrollTo({
                    top: position,
                    behavior: 'smooth',
                });
            }
        }, 100); // Adding a small delay to ensure the DOM is ready
    };

    useEffect(() => {
        if (location.state?.scrollTo) {
            scrollToSection(location.state.scrollTo);
        }
    }, [location]);

    const handlePopupOpen = () => {
        setIsPopupActive(true);
        setShowShimmer(true);
        window.history.pushState(null, '', `${path}`);
    };

    const handlePopupClose = () => {
        setIsPopupActive(false);
        setShowShimmer(false);
        window.history.back();
    };

    const handleEmailPopup = (course) => {
        setSelectedCourse(course);
        setIsEmailPopupActive(true);
        setIsPopupActive(false);
        window.history.pushState(null, '', `${path}`);
    };

    const handleEmailPopupClose = () => {
        setIsEmailPopupActive(false);
        setIsPopupActive(true);
        window.history.back();
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        if (email && selectedCourse) {
            const url = `https://mocktest.neethusacademy.com/mocktest.php?email=${email}&course=${selectedCourse}`;
            window.open(url, '_blank');
            setEmail('');
            handleEmailPopupClose();
        } else {
            toast.error('Please enter your email.');
        }
    };
    

    return (
        <>
            <div><Toaster/></div>
        
            <nav>
                <div className="container">
                    <div className="navMain">
                        <div className="navCol1">
                            <a href={`${path}/`} className="navLogo">
                                <img src={Logo} alt="Neethus Logo" />
                            </a>
                        </div>
                        <div className="navCol2">
                            <div className="navContact">
                                <a
                                    href="tel:+919633133374"
                                    onClick={(e) => {
                                        if (!window.location.href.includes('tel:')) {
                                            e.preventDefault();
                                            window.open('tel:+919633133374', '_self');
                                        }
                                    }}
                                >
                                    
                                    <TbPhoneCall /> Talk to Us
                                </a>
                            </div>
                            <div className="navPorofile">
                                <div className="navPorofileBox">
                                    <FaRegUser />
                                </div>
                                <div className="navPorofileDropdown">
                                    <ul>
                                        <li>
                                            <Link to={`${path}/delete`} className='navPorofileDropdownLinkBtn'>Delete Account</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

            {showShimmer && <div className="shimmer"></div>}

            {/* footer fixed menu */}
            <div className="footerFixedMenu">
                <div className="container">
                    <div className="footerFixedMenuMain">
                        <button
                            className={`footerFixedMenuBox ${activeSection === 'banner' ? 'active' : ''}`}
                            onClick={() => handleScroll('#banner')}
                        >
                            <div className="icon">
                                <TbSmartHome />
                            </div>
                            <p>Home</p>
                        </button>
                        <button
                            className={`footerFixedMenuBox ${activeSection === 'course' ? 'active' : ''}`}
                            onClick={() => handleScroll('#course')}
                        >
                            <div className="icon">
                                <TbBook />
                            </div>
                            <p>Course</p>
                        </button>
                        <button
                            className={`footerFixedMenuBox ${activeSection === 'mockTest' ? 'active' : ''}`}
                            onClick={handlePopupOpen}
                        >
                            <div className="icon">
                                <TbNotes />
                            </div>
                            <p>Mock Test</p>
                        </button>
                    </div>
                </div>
            </div>

            {/* mockTest course popup */}
            <div className={`mockTestCoursePopup ${isPopupActive ? 'mockTestCoursePopupActive' : ''}`}>
                <h3>Mock Test</h3>
                <div className="closeMockTestCoursePopup" onClick={handlePopupClose}>
                    <CgClose />
                </div>
                <div className="mockTestCoursePopupList">
                    <a href="https://studyingdynamic.com/mocktest/user/" target='_blank' className="mockTestCourseBox" onClick={handlePopupClose}>
                        <h4>NCLEX-RN</h4>
                        <div className="icon">
                            <GoChevronRight />
                        </div>
                    </a>
                    <div className="mockTestCourseBox" onClick={() => handleEmailPopup('IELTS')}>
                        <h4>IELTS</h4>
                        <div className="icon">
                            <GoChevronRight />
                        </div>
                    </div>
                    <div className="mockTestCourseBox" onClick={() => handleEmailPopup('PTE')}>
                        <h4>PTE</h4>
                        <div className="icon">
                            <GoChevronRight />
                        </div>
                    </div>
                    <div className="mockTestCourseBox" onClick={() => handleEmailPopup('TOEFL')}>
                        <h4>TOEFL</h4>
                        <div className="icon">
                            <GoChevronRight />
                        </div>
                    </div>
                </div>
            </div>

            {/* email popup */}
            <div className={`emailPopup ${isEmailPopupActive ? 'emailPopupActive' : ''}`}>
                <div className="closeEmailPopup" onClick={handleEmailPopupClose}>
                    <CgClose />
                </div>
                <h3>Enter your e-mail</h3>
                <form onSubmit={handleFormSubmit}>
                    <div className="formGroup">
                        <input
                            type="email"
                            placeholder="E-mail ID"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <div className="formBtnArea">
                        <button type="submit" className="submitEmailBtn">Submit</button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default Nav;
